<div class="p-2 rounded-2xl flex flex-col space-y-1 w-full"
     [style]="{'background-color': backgroundColor, 'font-family': font + ' !important'}"
     [ngClass]="{'justify-center items-center':question.isPrimary}">
    <div class="font-semibold text-xl" *ngIf="question.questionText"
         [ngClass]="{'text-center':question.isPrimary}">
        {{ question.isPrimary ? '' : questionNumber + '.' }} {{ question.questionText }}
    </div>
    <ng-container [ngSwitch]="question.questionType">
        <ng-container *ngSwitchCase="'TEXT'">
            <mat-form-field class="w-full">
                <input matInput>
            </mat-form-field>
        </ng-container>
        <ng-container *ngSwitchCase="'RATING_1_10'">
            <div class="flex justify-evenly items-center space-x-2">
                <button *ngFor="let r of rating1_10" (click)="sendResponse(r-1)"
                        [ngClass]="primaryRatingClass(r - 1)"
                        class="font-semibold border hover:bg-orange-500 px-1 w-5 h-5 min-w-5 text-sm md:text-md md:w-10 md:h-10 md:min-w-10">{{ r }}
                </button>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="'CHECKBOX'">
            <div class="flex flex-col space-y-1">
                <mat-checkbox *ngFor="let option of question.options1" [color]="'primary'">
                    <span [style]="{'font-family': font + ' !important'}">{{ option.optionText }}</span>
                </mat-checkbox>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="'RADIO'">
            <div class="flex flex-col space-y-1">
                <mat-radio-button *ngFor="let option of question.options1" [color]="'primary'">
                    <span [style]="{'font-family': font + ' !important'}">{{ option.optionText }}</span>
                </mat-radio-button>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="'CHIPS'">
            <div class="flex flex-wrap justify-center gap-2.5 py-2">
                <button type="button"
                        *ngFor="let option of question.options1; let i = index"
                        (click)="toggleChip(i)"
                        class="rounded-full px-4 py-2 text-sm font-bold border transition-all duration-150 ease-out"
                        [ngClass]="isChipSelected(i)
                            ? 'shadow-md scale-[1.03]'
                            : 'shadow-sm hover:shadow-md hover:-translate-y-0.5'"
                        [ngStyle]="chipStyle(i)">
                    {{ option.optionText }}
                </button>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="'SMILEY_1_5'">
            <div class="flex items-center space-x-3">
                <mat-icon (click)="sendResponse(i)" *ngFor="let icon of iconList;let i=index;"
                          [ngClass]="primarySmileyClass(i)"
                          class="icon-size-6 md:icon-size-8 hover:text-orange-500 hover:cursor-pointer"
                          [svgIcon]="icon"></mat-icon>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="'STAR_1_5'">
            <div class="flex items-center space-x-3">
                <rating [rating]="isValueSelected ? rating+1 : question.isPrimary ? 0 : rating"
                        (sendResponseToQuestion)="sendResponse($event-1)"
                        [className]="'icon-size-5 md:icon-size-8 hover:cursor-pointer hover:text-orange-500'"></rating>
            </div>
        </ng-container>
    </ng-container>
</div>
<hr class="my-2 mx-0" *ngIf="!question.isPrimary">
